import Vue from "vue";
import vant from 'vant';
import 'vant/lib/index.css';

Vue.use(vant)